module.exports = __webpack_public_path__ + "static/img/switch.67ff45e5.svg";